import publicIp from 'public-ip';
import {useEffect, createContext, useState} from 'react';
export const IPContext = createContext('');

export default function IpProvider({children}: any) {
    const [userIp, setUserIp] = useState<string>('');

    const getIPWithRetry = async (fn: () => Promise<void>, trial: number) => {
        fn().catch((error) => {
            if (error instanceof Error && trial < 3) getIPWithRetry(fn, trial + 1);
            else throw error;
        });
    };

    useEffect(() => {
        async function fetchIp() {
            const ip = await publicIp.v4();
            setUserIp(ip);
        }

        function getIP() {
            getIPWithRetry(fetchIp, 0).catch(console.error);
        }

        getIP();

        addEventListener('online', getIP);
        return function () {
            removeEventListener('online', getIP);
        };
    }, []);
    return <IPContext.Provider value={userIp}>{children}</IPContext.Provider>;
}
